import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import Title from "../../components/Title/Title";
import '../../styles/Source-Link.css';
import Card from '../../components/Card/Card'

export default function GuardianAngel() {

    return (
        <div>
            <NavBar/>
            <Title text={"O Anjo da Guarda"}/>
            
            <div className="card-container">
            <Card Nome={"Nosso Santo Anjo da Guarda"} Imagem={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Angels/Guardian_Angel.jpg"}/>
            </div>            

            <p className="info-text">
            "Desde a infância até a morte, a vida humana é cercada pela sua proteção e intecessão.
            '. Cada pessoa tem a seu lado um anjo como protetor e pastor para conduzi-lo na vida.'<br/>
            Ainda aqui na terra, a vida cristão participa na fé, na sociedade bem-aventurada dos anjos e dos homens, unidos em Deus"(CIC 336)            
            </p>  
            <p className="info-text">
            O Anjo da guarda é o instrumento da solicitude paterna de Deus a nosso respeito e o intermediário de Sua benevolência. Muitas das graças a nós destinadas passam por ele. O anjo faz por nós mais do que pensamos, pois como ele, sua ação também é invisível.
            Somente no Céu conseguiremos saber tudo aquilo que lhe devemos, todos os males da alma e do corpo de que nos preserva, todos os bens que busca para todos nós, todas as graças que nos assegura, todos os serviços que nos presta.
            </p>  
            <p className="info-text">
                O alimento mais perfeito para o anjo da guarda, é a nossa disposição de fazer a vontade de Deus,
                São Bernardo de Claraval resume em três atitudes o comportamento que as pessoas devem ter em relação ao anjo da guarda:<br/>

                <strong>- Atitude de respeito:</strong> porque é um ser mais perfeito e mais digno do que nós.<br/>
                <strong>- Atitude de confiança:</strong> para confidenciar-lhe as dificuldades, pedir ajuda e disposição para cumprirmos nossa missão da vida.<br/>

                <strong>- Atitude de amor, devoção e gratidão:</strong> A fim de que sejamos dóceis às suas inspirações, porque na realidade são inspirações de Deus; Ter confiança nas iniciativas dele e agradecer sua preciosa e benéfica intercessão junto ao Criador.
            </p>

            <Title text={"Orações ao Anjo da Guarda"}/>
            <p className="info-text">
                Santo anjo do Senhor, meu zeloso guardador, se a ti me confiou a piedade divina, sempre me rege, guarda, governa e ilumina,amém.
            </p>
            <p className="info-text">
                Ó meu santo anjo da guarda, vós que me fostes dado por Deus como companheiro para toda a minha vida, salvai-me para a eternidade e cumnpri vossa obrigação para comigo, a qual vos foi confiada pelo Deus de amor. <br/>
                Sacudi-me da tibieza e livrai-me de minha fraqueza. <br/>
                Preservai-me de qualquer caminho ou pensamento mau. Abri meus olhos para Deus e para cruz. <br/>
                Fechai meus ouvidos às inspirações do inimigo maligno.<br/>
                Velai sobre mim quando durmo e fortificai-me durante o dia, para o cumprimento do dever a para cada sacríficio.<br/>
                Deixai-me ser um dia de vossa alegria e vossa recompensa no céu. Amém.
            </p>

            <Footer/>
        </div>
    )
}